import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b35e09ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tp-modal" }
const _hoisted_2 = { class: "tp-modal__box" }
const _hoisted_3 = { class: "tp-modal__box-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tp-modal__box-inner-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Ваша почта:"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "tp-modal__input"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "пустое поле")
], -1))
const _hoisted_5 = { class: "tp-modal__box-inner-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tp-modal__box-inner-row" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "terms-label" }, [
    /*#__PURE__*/_createElementVNode("input", { type: "checkbox" }),
    /*#__PURE__*/_createTextVNode("Я согласен на обработку персональных данных")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tp_button = _resolveComponent("tp-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_tp_button, { class: "tp-modal-button" }, {
            default: _withCtx(() => [
              _createTextVNode("Отправить")
            ]),
            _: 1
          })
        ]),
        _hoisted_6
      ])
    ])
  ]))
}